// extracted by mini-css-extract-plugin
export default {"contactsWrapper":"ContactsPage_contactsWrapper__DIIMa","contactsTitle":"ContactsPage_contactsTitle__1OMJY"};